import { gql } from "@apollo/client"

export const MY_SITE_QUERY = gql`
    query MySite {
        mySite {
            name
            status
            settings {
                general {
                    timezone
                    language
                }
                notifications {
                    captures {
                        pod {
                            enabled
                            imageRequired
                        }
                        pop {
                            imageRequired
                            enabled
                        }
                    }
                }
            }
            documentTypes {
                POD_Signature
                POP
                POP_Signature
                POD
            }
            type
            tier
            features
        }
    }
`
